import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Badge} from 'reactstrap'

import Loader from '../Loader/Loader.jsx'

import api from '../../../api.js'

import Date from '../../components/Moment/Date.jsx'
import {getStatus} from '../../services/progessiService.js'

export default class ProgessiMissions extends PureComponent {
  static propTypes = {
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      isProgessiActive: PropTypes.bool.isRequired
    }).isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      missions: [],
    }
  }

  componentDidMount() {
    this.loadData(this.props.user.id)
  }

  componentDidUpdate = async (prevProps, prevState, prevContext) => {
    if (prevProps.user.id !== this.props.user.id) {
      await this.loadData(this.props.user.id)
    }
  }

  loadData = async (userId) => {
    try {
      this.setState({loading: true})
      const response = await api.progessi.getWorkEffortItemsForUser({user: userId})

      this.setState({
        loading: false,
        missions: response.data,
      })
    } catch (e) {
      this.setState({loading: false})
    }
  }

  render() {
    if (this.state.loading) {
      return <Loader visible={this.state.loading}/>
    }

    const {user} = this.props

    return <Fragment>
      <div className="text-center mb-4">
        <Badge color={user.isProgessiActive ? 'success' : 'warning'} className="mx-1">
          {user.isProgessiActive ? 'En mission' : 'Pas en mission'}
        </Badge>
        <p>
          Ce consultant {user.isProgessiActive ? 'est actuellement' : 'n\'est actuellement pas'} en mission chez un
          client Twineeds
        </p>
      </div>
      {this.state.missions.length ?
        <div className="row px-5">
          <table className="col-12 table table-striped table-dark w-100">
            <thead>
              <tr>
                <th scope="col">Id projet</th>
                <th scope="col">Date début mission</th>
                <th scope="col">Date fin mission</th>
                <th scope="col">Work effort name (nom consultant / client)</th>
                <th scope="col">TJ achat</th>
                <th scope="col">Statut</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.missions.map((mission) => (
                  <tr key={mission.id}>
                    <th scope="row">{mission.work_effort_id}</th>
                    <td>{<Date format="dd/MM/yyyy" date={mission.from_date} />}</td>
                    <td>{mission.thru_date ? <Date format="dd/MM/yyyy" date={mission.thru_date} /> : ''}</td>
                    <td>{mission.work_effort_name}</td>
                    <td>{mission.amount_purchases}</td>
                    <td>{getStatus(mission.availability_status_id)}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div> :
        <p className="text-center">Aucune mission</p>
      }
    </Fragment>
  }
}
